import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }

import { computed } from "vue";
import dayjs from "dayjs";
import Datepicker from "vue3-date-time-picker";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormDatepicker',
  props: {
    placeholder: null,
    modelValue: null,
    error: null,
    position: null,
    autoApply: { type: Boolean },
    enableTimePicker: { type: Boolean },
    monthPicker: { type: Boolean },
    timePicker: { type: Boolean },
    closeOnAutoApply: { type: Boolean },
    hideInputIcon: { type: Boolean }
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:model-value', v: string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  placeholder?: string;
  modelValue?: string;
  error?: string;
  position?: 'left' | 'right' | 'center';
  autoApply?: boolean,
  enableTimePicker?: boolean,
  monthPicker?: boolean,
  timePicker?: boolean,
  closeOnAutoApply?: boolean,
  hideInputIcon?: boolean,
};






const computedValue = computed(() => {
  if (props.modelValue) {
    if (props.monthPicker) {
      const date = dayjs(props.modelValue).toDate();

      return {
        month: date.getMonth(),
        year: date.getFullYear(),
      };
    } else if (props.timePicker) {
      if (props.modelValue.includes(":")) {
        const [h, m] = props.modelValue.split(":");
        return { hours: parseInt(h), minutes: parseInt(m) };
      }
    }
  }

  return props.modelValue;
})


const doEmit = (
  date:
    | Date
    | { month: number; year: number }
    | { hours: number; minutes: number }
    | null
) => {
  let formattedDate = null;
  if (date !== null) {
    if (date instanceof Date) {
      formattedDate = dayjs(date).format("YYYY-MM-DD");
    } else if ("year" in date && "month" in date) {
      formattedDate = dayjs(new Date(date.year, date.month, 1)).format(
        "YYYY-MM-DD"
      );
    } else if ("hours" in date && "minutes" in date) {
      const h = date.hours < 10 ? `0${date.hours}` : date.hours;
      const m = date.minutes < 10 ? `0${date.minutes}` : date.minutes;
      formattedDate = `${h}:${m}`;
    }
  }

  emit("update:model-value", formattedDate);
}

return (_ctx: any,_cache: any) => {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Datepicker), {
      enableTimePicker: __props.enableTimePicker,
      monthPicker: __props.monthPicker,
      timePicker: __props.timePicker,
      autoApply: __props.autoApply,
      placeholder: __props.placeholder,
      position: __props.position,
      closeOnAutoApply: __props.closeOnAutoApply,
      hideInputIcon: __props.hideInputIcon,
      modelValue: _unref(computedValue),
      "onUpdate:modelValue": doEmit
    }, null, 8, ["enableTimePicker", "monthPicker", "timePicker", "autoApply", "placeholder", "position", "closeOnAutoApply", "hideInputIcon", "modelValue"]),
    _createVNode(_component_Error, { error: __props.error }, null, 8, ["error"])
  ]))
}
}

})